import { ConfigProvider, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from '../PublicHeader/PublicHeader';
import { PublicFooter } from '../PublicFooter/PublicFooter';
import { StyledLayout } from './PublicLayout.styles';
import { Styling } from 'app/cross-cutting-concerns/styling/Styling';
import { DependencyInjection } from 'app/cross-cutting-concerns/dependency-injection/DependencyInjection';
import { KCCThemeGlobalStyles } from 'config/theme/kccTheme/globalStyles';

const { Content } = Layout;

export const PublicLayout = (): JSX.Element => {
  const styling = DependencyInjection.resolve<Styling>(Styling);
  const kccAntdTheme = styling.getAntDesignKCCThemeConfig();

  return (
    <ConfigProvider
      theme={kccAntdTheme}
      input={{ className: 'kcc-theme-input' }}
      select={{ className: 'kcc-theme-select' }}
      modal={{ className: 'kcc-theme-modal' }}
      card={{ className: 'kcc-theme-card' }}
      checkbox={{ className: 'kcc-theme-checkbox' }}
      tooltip={{ className: 'kcc-theme-tooltip' }}
      wave={{ disabled: true }}
    >
      <KCCThemeGlobalStyles />
      <StyledLayout>
        <PublicHeader />
        <Content className="layout-content">
          <Outlet />
          <PublicFooter />
        </Content>
      </StyledLayout>
    </ConfigProvider>
  );
};
